module.exports = __webpack_public_path__ + "img/cloud-outline.afa4ce8b.webp";